import { ADDFLIGHT, REMOVEFLIGHT } from './actionTypes';

export const addFlight = (flightData) => {
    return {
        type: ADDFLIGHT,
        payload: flightData
    };
};

export const removeFlight = (flightId) => {
    return {
        type: REMOVEFLIGHT,
        payload: flightId
    };
};